// extracted by mini-css-extract-plugin
module.exports = {"container":"SQRTokenSection_container__nW_Gh"};